<template>
  <div class="spring-spinner">
    <div class="spring-spinner-part top">
      <div class="spring-spinner-rotator" />
    </div>
    <div class="spring-spinner-part bottom">
      <div class="spring-spinner-rotator" />
    </div>
  </div>
</template>

<script>
// Epic spinners
export default {}
</script>

<style scoped>
.spring-spinner,
.spring-spinner * {
  box-sizing: border-box;
}

.spring-spinner {
  height: 90px;
  width: 90px;
}

.spring-spinner .spring-spinner-part {
  overflow: hidden;
  height: calc(90px / 2);
  width: 90px;
}

.spring-spinner .spring-spinner-part.bottom {
  transform: rotate(180deg) scale(-1, 1);
}

.spring-spinner .spring-spinner-rotator {
  width: 90px;
  height: 90px;
  border: calc(90px / 7) solid transparent;
  border-right-color: #0fb625;
  border-top-color: #0fb625;
  border-radius: 50%;
  box-sizing: border-box;
  animation: spring-spinner-animation 3s ease-in-out infinite;
  transform: rotate(-200deg);
}

@keyframes spring-spinner-animation {
  0% {
    border-width: calc(90px / 7);
  }
  25% {
    border-width: calc(90px / 23.33);
  }
  50% {
    transform: rotate(115deg);
    border-width: calc(90px / 7);
  }
  75% {
    border-width: calc(90px / 23.33);
  }
  100% {
    border-width: calc(90px / 7);
  }
}
</style>